// Colores para badges de Cliente Status - Tema Oscuro
export const getClienteStatusColor = (status) => {
  // Normalizar el status (mayúsculas a primera mayúscula)
  const normalizedStatus = status ? status.toLowerCase().replace(/^\w/, c => c.toUpperCase()) : '';
  
  const colors = {
    'Activo': 'badge-activo',
    'Inactivo': 'badge-inactivo', 
    'Moroso': 'badge-moroso',
    'Convenio': 'badge-convenio',
    'Finiquito': 'badge-finiquito',
    'Retirado': 'badge-retirado',
    'Retenido': 'badge-retenido',
    'Cxpr': 'badge-cxpr',
    'Solvente': 'badge-solvente',
    // También manejar variaciones exactas del Excel
    'ACTIVO': 'badge-activo',
    'INACTIVO': 'badge-inactivo',
    'MOROSO': 'badge-moroso', 
    'CONVENIO': 'badge-convenio',
    'FINIQUITO': 'badge-finiquito',
    'RETIRADO': 'badge-retirado',
    'RETENIDO': 'badge-retenido',
    'CXPR': 'badge-cxpr',
    'SOLVENTE': 'badge-solvente',
  };
  return colors[status] || colors[normalizedStatus] || 'badge-default';
};

// Colores para badges de Expediente Status - Tema Oscuro
export const getExpedienteStatusColor = (status) => {
  const colors = {
    'En espera': 'badge-en-espera',
    'En proceso': 'badge-en-proceso',
    'En proceso 2': 'badge-en-proceso',
    'En Proceso 3': 'badge-en-proceso',
    'Completado': 'badge-completado',
  };
  return colors[status] || 'badge-default';
};

// Colores para roles de usuarios
export const getRoleColor = (role) => {
  const colors = {
    'admin': 'bg-purple-100 text-purple-800 border-purple-300',
    'auditor': 'bg-blue-100 text-blue-800 border-blue-300',
    'consulta': 'bg-gray-100 text-gray-800 border-gray-300',
  };
  return colors[role] || 'bg-gray-100 text-gray-800 border-gray-300';
};

export const getRoleLabel = (role) => {
  const labels = {
    'admin': 'Admin',
    'auditor': 'Auditor',
    'consulta': 'Consulta',
  };
  return labels[role] || role;
};
